import { render, staticRenderFns } from "./ShiftSwapCancellationDialog.vue?vue&type=template&id=fa32440c&scoped=true&"
import script from "./ShiftSwapCancellationDialog.vue?vue&type=script&lang=ts&"
export * from "./ShiftSwapCancellationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa32440c",
  null
  
)

export default component.exports